// Sets a runtime variable so CDN assets continue to point to the CDN
__webpack_public_path__ = (window.ASSETS_URL || '') + '/static/dist/';
